module.exports = __webpack_public_path__ + "img/SES_220140036.af8d79cc.jpg";